import { Link } from "react-router-dom";

export const Logo = ({ dark = false }) => (
  <Link to="/" data-testid="logo-home-link" className="flex items-center select-none">
    <img
      src="/logo-wordmark.webp"
      alt="Analytics 4 People — Working better with data"
      className={`h-8 sm:h-9 w-auto ${dark ? "rounded-md bg-white px-2 py-1" : ""}`}
    />
  </Link>
);
